import React from 'react';
import { useFragment } from 'react-relay/hooks';

import { createStyles, ListItemText, Theme, withStyles, WithStyles } from '@material-ui/core';
import { graphql } from 'babel-plugin-relay/macro';

import { ListItemGroup_EmbedNode$key } from './__generated__/ListItemGroup_EmbedNode.graphql';
import ListItemNode, { ListItemNodeProps } from './ListItemNode';
import TypographyNodeName from './TypographyNodeName';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    listItem: {
      alignItems: 'flex-start',
    },
    listItemText: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: 0,
    },
    listItemTextName: {
      flex: 1,
      marginRight: unit * 2,
    },
  });

export interface ListItemGroupProps
  extends Omit<ListItemNodeProps, 'classes' | 'fragmentRef'>,
    WithStyles<typeof styles> {
  fragmentRef: ListItemGroup_EmbedNode$key;
}

const ListItemGroup: React.FC<ListItemGroupProps> = ({ classes, fragmentRef, ...rest }) => {
  const node = useFragment<ListItemGroup_EmbedNode$key>(
    graphql`
      fragment ListItemGroup_EmbedNode on Node {
        ...ListItemNode_EmbedNode
        ... on Group {
          ...TypographyNodeName_EmbedNode
        }
      }
    `,
    fragmentRef,
  );

  return (
    <ListItemNode fragmentRef={node} className={classes.listItem} {...rest}>
      <ListItemText
        className={classes.listItemText}
        disableTypography
        primary={
          <TypographyNodeName
            className={classes.listItemTextName}
            fragmentRef={node}
            variant="body1Bold"
            color="primary"
          />
        }
      />
    </ListItemNode>
  );
};

export default withStyles(styles)(ListItemGroup);
